module.exports = "/static/js/4b918384531d08c4d48e4fc31787ee5a.png";